import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useUptimeConfigPlatformDeleteMutation } from "@/v2-backoffice-client/uptime/configPlatform/delete/uptime.configPlatform.delete.mutation"

export type UptimeConfigPlatformDeleteButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  platformId: string
  onCompleted?(): void
}

function UptimeConfigPlatformDeleteButton(
  props: UptimeConfigPlatformDeleteButtonProps,
) {
  const { platformId, onCompleted, ...buttonProps } = props

  const [del, { loading, error }] = useUptimeConfigPlatformDeleteMutation({
    onCompleted,
  })
  errorToast(error ?? null, { title: "Failed to delete platform" })

  return (
    <ConfirmButton
      variant="ghost"
      size="sm"
      iconSrc="trash"
      content="Delete platform"
      confirmContent="Delete platform? Categories that point at it must be moved first."
      isLoading={loading}
      onConfirm={async () => {
        await del({ variables: { id: platformId } })
      }}
      {...buttonProps}
    />
  )
}

export default UptimeConfigPlatformDeleteButton
